export default {
  featuredExperiences: 'Pengalaman Unggulan Kami',
  searchAllExperiences: 'Cari semua Pengalaman',
  searchAll: 'Cari Semua',
  groupSize: 'Ukuran Grup',
  eventSize: 'Ukuran Acara',
  upTo: 'Hingga',
  whatWeDo: 'Apa yang Akan Kita Lakukan',
  hostedBy: 'Diselenggarakan Oleh',
  whatsIncluded: 'Apa yang Termasuk',
  avail: 'Ketersediaan',
  whereWeAre: 'Di Mana Kita Berada',
  experienceCalendar: 'Kalender Pengalaman',
  experienceCancelled: 'Pengalaman Dibatalkan',
  experienceStartingPrice: 'Dari {{price}}',
  experienceTotalPrice: 'Total {{price}}',
  at: 'pada',
  viewPrivateSessAvailability: 'Lihat ketersediaan sesi privat',
  selectDuration: 'Durasi',
  selectStartTime: 'Waktu mulai',
  selectSession: 'Pilih Sesi',
  sessionsCount: '{{count}} waktu — pilih waktu',
  noAvailability: 'Tidak Ada Ketersediaan',
  select: 'Pilih',
  slotLeft: '{{remainSlots}} slot tersisa',
  slotsLeft: '{{remainSlots}} slot tersisa',
  spotsLeft: '{{count}} tersisa',
  spotsLeftAriaLabel: '{{count}} tempat tersisa',
  bookExperience: 'Pesan Pengalaman',
  book: 'Pesan',
  learnMore: 'Pelajari lebih lanjut',
  apply: 'Terapkan',
  maxPartySizes: 'Maksimal {{maxGroupSize}} slot per rombongan',
  maxPartySize: 'Maksimal {{maxGroupSize}} slot per rombongan',
  selectSessionValidation: 'Silakan pilih sesi',
  selectParticipantValidation: 'Silakan pilih peserta',
  selectDateValidation: 'Silakan pilih tanggal',
  reminders: 'Pengingat',
  seeOtherDates: 'Lihat tanggal lain',
  location: 'Lokasi',
  about: 'Tentang',
  allExperiences: 'Semua pengalaman',
  soldOut: 'Habis Terjual',
  addOns: 'Tambahan',
  reviews: 'Ulasan',
  reviewSingular: 'ulasan',
  reviewPlural: 'ulasan',
  dateOfExperience: 'Tanggal pengalaman',
  readLess: 'Baca Lebih Sedikit',
  readMore: 'Baca Selengkapnya',
  seeMore: 'Lihat Selengkapnya',
  details: 'Detail',
  durationHour: 'jam',
  durationHours: 'jam',
  durationMinutes: 'mnt',
  theFollowingVideoDoesNotContainAnyAudio:
    'Video berikut tidak mengandung audio',
  by: 'Oleh',
  chooseATime: 'Pilih waktu untuk {{title}}',
  amenities: 'Fasilitas',
  ticketSalesOpenIn: 'Penjualan tiket dibuka dalam',
  ticketSalesOpen: 'Penjualan tiket dibuka',
  ticketSalesCloseIn: 'Penjualan tiket ditutup dalam',
  ticketSalesClose: 'Penjualan tiket ditutup',
  ticketSalesClosed: 'Penjualan tiket telah ditutup',
  comingSoon: 'Segera hadir',
  inPartnershipWith: 'Bekerja sama dengan',
  notFoundExperienceTitle: 'Pengalaman ini tidak lagi tersedia',
  notFoundExperienceSubtitle:
    'Mungkin telah dibatalkan publikasinya, atau tautan mungkin tidak lagi valid.',
  deadLinkRecoverySubtitle: 'Temukan pengalaman lain yang dapat dipesan',
  viewAllExperiences: 'Lihat Semua Pengalaman',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Dapatkan 5 Poin Dasar</strong> per $1 USD yang memenuhi syarat yang dibelanjakan saat masuk ke akun World of Hyatt Anda untuk memesan pengalaman ini</p>',
      basePoints:
        '<p><strong>Dapatkan 10 Poin Dasar</strong> per $1 USD yang memenuhi syarat yang dibelanjakan saat masuk ke akun World of Hyatt Anda untuk memesan pengalaman ini</p>',
      additionalBonusPoints:
        '<p><strong>Dapatkan tambahan 4 Poin Bonus</strong> per $1 USD yang memenuhi syarat yang dibelanjakan saat Anda memesan dengan Kartu Kredit World of Hyatt Anda</p>',
      additionalBonusPointsTier:
        '<p><strong>Dapatkan hingga 30% Poin Bonus tambahan</strong> tergantung pada status tingkat Anda</p>',
      payWithPoints:
        '<p><strong>Bayar dengan Poin</strong> saat memesan pengalaman ini</p>',
    },
  },
};
